<template>
  <RouterLink
    :to="{ name: 'lessons-detail', params: { lessonId: lesson.id } }"
    class="group @container relative flex w-full flex-row items-center gap-4 p-2"
    ><div
      v-if="lesson.lessonImpulse"
      class="rounded-medium aspect-4/3 h-12 shrink-0 overflow-hidden"
    >
      <img
        :src="lesson.lessonImpulse.image"
        :alt="lesson.lessonImpulse.title"
        class="h-full object-cover transition-transform duration-300 group-hover:scale-105 group-hover:rotate-2"
      />
    </div>
    <div class="flex grow flex-col @2xl:flex-row @2xl:gap-2">
      <span class="text-title-medium line-clamp-1 grow">{{ lesson.title }}</span>
      <div class="flex flex-row gap-1">
        <div
          v-if="lesson.feedbackStartedAt && !lesson.endedAt"
          class="bg-tertiary-container text-on-tertiary-container rounded-small text-label-medium flex flex-row items-center gap-2 px-2 py-1 whitespace-nowrap"
        >
          <div class="bg-tertiary animate-color-pulse h-2 w-2 rounded-full"></div>
          <span>
            {{ $t('lumia.lesson.feedbackProgress') }}
          </span>
        </div>
        <div
          v-if="lesson.endedAt"
          class="text-on-surface rounded-small text-label-medium flex flex-row items-center gap-1 px-2 py-1 whitespace-nowrap"
          :class="[
            onContainer && 'bg-surface-container-lowest',
            !onContainer && 'bg-surface-container',
          ]"
        >
          <span>{{ $t('lumia.lesson.endedAt') }} </span>
          <TimeAgo :date="lesson.endedAt" />
        </div>
        <div
          v-else
          class="text-on-surface rounded-small text-label-medium flex flex-row items-center gap-1 px-2 py-1 whitespace-nowrap"
          :class="[
            onContainer && 'bg-surface-container-lowest',
            !onContainer && 'bg-surface-container',
          ]"
        >
          <span>{{ $t('lumia.lesson.startedAt') }} </span>
          <TimeAgo :date="lesson.startedAt" />
        </div>
        <div
          v-for="team in lesson.teams"
          :key="team.id"
          class="text-on-surface rounded-small text-label-medium flex flex-row items-center gap-1.5 py-1 pr-2 pl-1.5 whitespace-nowrap"
          :class="[
            onContainer && 'bg-surface-container-lowest',
            !onContainer && 'bg-surface-container',
          ]"
        >
          <BaseTeamAvatar :name="team.name" size="18" />
          <span>
            {{ team.name }}
          </span>
        </div>
      </div>
    </div>

    <BaseStateLayer />
  </RouterLink>
</template>

<script lang="ts" setup>
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import TimeAgo from '@/core/components/base/time-ago/TimeAgo.vue'
  import type { LessonSummary } from '../models/lesson'
  import BaseTeamAvatar from '@/core/components/base/avatar/BaseTeamAvatar.vue'

  interface Props {
    lesson: LessonSummary
    onContainer?: boolean
  }

  defineProps<Props>()
</script>
